<template>
  <div
    class="xcTree"
    @contextmenu.prevent="rightHand($event)"
  >
    <div
      class="xc-tree-groups"
      :class="{'borderClass':border}"
    >
      <my-tree-group
        :label="label"
        :origin="origin"
        :data="origin"
        :type="type"
        :indeterminate="indeterminate"
        :hasChecked="checked"
        :showCheckbox="showCheckbox"
        :multiple="multiple"
        :expand="onToggleExpand"
        :linked="linked"
        :selectText="onSelectText"
        :checkedBox="onChecked"
        :updateData="onUpdateData"
        :rightClick="onRightClick"
        :nodeClick="onNodeClick"
      >
      </my-tree-group>
    </div>
  </div>
</template>

<script>

import TreeGroup from "./TreeGroup.vue"

export default {
  name: "XcTree",
  data() {
    return {
      id: 0,
      checked: [],
      origin: [],
      objTree: {}
    }
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: "",
    },
    //是否显示选择框
    showCheckbox: {
      type: Boolean,
      default: false
    },
    //是否多选
    multiple: {
      type: Boolean,
      default: false
    },
    //是否联动
    linked: {
      type: Boolean,
      default: false
    },
    //是否展开
    expand: {
      type: Number,
      default: -1 //默认不展开
    },
    //    半选是否表示选中
    indeterminate: {
      type: Boolean,
      default: false
    },
    type: {
      type: Number,
      default: 0,
    }
  },
  computed: {
    border: function () {
      return this.showCheckbox && this.origin.length == 1
    },
  },
  watch: {
    //  当外部数据发生变化的时候同步内部数据(直接操作外部数据）
    data(v) {
      console.log("重新渲染该树");
      this.origin = v;
      this.initData(this.origin, -1, 0);
      var result = this.getChecked(this.origin, []);
      this.checked = result;
      this.$emit("init", { data: this.origin, checked: this.checked, tree: this })
    },
    //  当内部数据发生变化同步外部数据（直接操作origin）
    origin(v) {
        console.log("同步外部数据")
      this.$emit('update:data', v);
    }
  },
  components: {
    "MyTreeGroup": TreeGroup
  },
  methods: {
    //判断该节点的孩子中是否有未选中,若有返回true
    noChecked: function (data) {
      if (data.children.length) {
        for (let x of data.children) {
          if (x.checked == true) {
            var result = this.noChecked(x);
            if (result) {
              return result;
            }
          } else {
            return true;
          }
        }
      } else {
        return false;
      }
    },
    //判断该节点的孩子中是否有选中，若有返回true
    allChecked: function (data) {
      if (data.children.length) {
        for (let x of data.children) {
          if (x.checked == true) {
            return true;
          } else {
            var result = this.allChecked(x);
            if (result) {
              return result;
            }
          }
        }
      } else {
        return false;
      }
    },
    //    处理数组
    initData: function (arr, treeParentId, level) {
      if (arr.length > 0) {
        //    遍历所有节点
        for (let x of arr) {



          //添加treeParent属性
        //   if (treeParent) {
        //     x.treeParent = treeParent;
        //   } else {
        //     x.treeParent = null;
        //   }

          if (level <= this.expand) {
            if (!x.expand) {
              this.$set(x, "expand", true)
            }
          } else {
            if (!x.expand) {
              this.$set(x, "expand", false)
            }
          }
          //添加checked属性
          if (!x.checked) {
            // x.checked=false;
            this.$set(x, "checked", false);
            //该节点的孩子节点存在选中
            if (this.allChecked(x)) {
              this.$set(x, "indeterminate", "indeterminate")
            } else {
              //添加indeterminate属性（半选）
              this.$set(x, "indeterminate", null)
            }
          } else {
            if (this.noChecked(x)) {
              this.$set(x, "indeterminate", "indeterminate")
            } else {
              //添加indeterminate属性（半选）
              this.$set(x, "indeterminate", null)
            }
          }
          //添加active属性
          if (x.active == undefined) {
            this.$set(x, "active", false)
          }
          //添加isHover属性{
          if (x.isHover == undefined) {
            this.$set(x, "isHover", false)
          }
          //添加level属性
          x.level = level;
          var nextLevel = level + 1;
          x.treeId = this.id++;
          x.treeParentId = treeParentId;


          this.objTree[x.treeId] = x;

          if (x.children.length) {
            this.initData(x.children, x.treeId, nextLevel)
          }
        }
      } else {
        return;
      }
    },
    //更新数据
  /*  updateData: function (data) {
      console.log("重新渲染该树");
      this.origin = data;
      this.initData(this.origin, -1, 0)
    },*/
    //    获取已选元素
    getChecked: function (arr, result) {
      if (arr.length > 0) {
        for (let x of arr) {
          if (x.checked) {
            result.push(x);
          }
          this.getChecked(x.children, result)
        }
      }
      return result;
    },
    //    监听折叠事件
    onToggleExpand: function (data) {
      this.$emit("expanded", data)
    },
    //    监听点击文字事件
    onSelectText: function (data) {
      this.$emit("selected", data)
    },
    //    监听点击选择框事件
    onChecked: function (data) {
      this.checked = this.getChecked(this.origin, []);
      this.$emit("checked", { target: data, checked: this.checked });
    },
    //    监听对父组件数据的更新
    onUpdateData: function (data) {
      this.$emit("updated", data)
    },
    //    外层点击右键
    rightHand: function (e) {
      if (this.showCheckbox) {
        var data = {
          event: e,
        }
        this.onRightClick(data);
      }
    },
    //    点击节点
    onRightClick: function (data) {
      this.$emit("rightClick", data)
    },
      //点击节点
      onNodeClick(data){
          this.$emit("nodeClick", data)
      }
  },
  created() {
    this.origin = this.data;
    this.initData(this.origin, -1, 0);
    var result = this.getChecked(this.origin, []);
    this.checked = result;
    this.$emit("init", { data: this.origin, checked: this.checked, tree: this })
  }
}
</script>

<style lang="scss" scoped>
.xcTree {
  // overflow-x: auto;
  /*width: 100%;*/
  width: max-content;
  min-width: 100%;
}

.xc-tree-groups {
  width: 100%;
  /*overflow-x: scroll;*/
  /*padding: 20px 18px;*/
  position: relative;
}
.borderClass {
  /*&:after {
            content: "";
            display: block;
            width: 1px;
            height: calc(100% - 16px);
            top: 16px;
            left: 8px;
            background: #cfd5e0;
            position: absolute;
        }*/
}
</style>
